<template>
  <div>
    <el-form :inline="true" style="margin-bottom:8px">
      <el-form-item>
        <el-button v-if="isAuth('plm:plmMbom:convert') || isAuth('plm:plmEbom:save')" type="primary" size="small" @click="openConvert">EBOM 转 MBOM</el-button>
      </el-form-item>
    </el-form>
    <plm-mbom-list ref="bom" />

    <el-dialog title="EBOM 转 MBOM" :visible.sync="convertVisible" width="min(460px, calc(100vw - 24px))" append-to-body>
      <el-form label-width="110px">
        <el-form-item label="父物料" required>
          <el-input v-model="convertForm.materialCode" readonly placeholder="点击选择">
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="EBOM版本" required>
          <el-input v-model="convertForm.ebomVersion" placeholder="如 V1" />
        </el-form-item>
        <el-form-item label="新MBOM版本">
          <el-input v-model="convertForm.newMbomVersion" placeholder="留空自动递增" />
        </el-form-item>
      </el-form>
      <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
      <span slot="footer">
        <el-button @click="convertVisible = false">取消</el-button>
        <el-button type="primary" :loading="convertLoading" @click="submitConvert">转换</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import PlmMbomList from './PlmMbomList.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmMbom',
  components: { PlmMbomList, MaterialSelector },
  data() {
    return {
      convertVisible: false, convertLoading: false, materialSelectorVisible: false, permCodes: [],
      convertForm: { materialId: '', materialCode: '', ebomVersion: '', newMbomVersion: '' }
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    openConvert() {
      const row = this.$refs.bom && this.$refs.bom.selected
      this.convertForm = {
        materialId: row ? row.materialId : '',
        materialCode: row ? row.materialCode : '',
        ebomVersion: '',
        newMbomVersion: ''
      }
      this.convertVisible = true
    },
    onMaterialSelect(row) {
      this.convertForm.materialId = row.materialId
      this.convertForm.materialCode = row.materialCode
      this.materialSelectorVisible = false
    },
    submitConvert() {
      if (!this.convertForm.materialId || !this.convertForm.ebomVersion) {
        this.$message.warning('请选择父物料并填写 EBOM 版本')
        return
      }
      this.convertLoading = true
      request.post('/plm/plmMbom/convertFromEbom', this.convertForm).then(() => {
        this.$message.success('转换成功，请在列表中审批并发布 MBOM')
        this.convertVisible = false
        if (this.$refs.bom) this.$refs.bom.load()
      }).catch(() => {}).finally(() => { this.convertLoading = false })
    }
  }
}
</script>
